import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="apropos" data-testid="about-section" className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-6 mb-12">
            <div className="h-[1px] w-16 bg-[#b39a73]" />
            <h2
              className="text-3xl md:text-4xl text-[#2E3A34] tracking-[0.05em]"
              style={{ fontFamily: "'Cinzel', serif" }}
              data-testid="about-title"
            >
              À propos
            </h2>
            <div className="h-[1px] w-16 bg-[#b39a73]" />
          </div>

          <div className="space-y-6">
            <p
              className="text-lg md:text-xl text-[#4E4A45] leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              AŪRA HOME CARE est un service de surveillance et gestion de propriété à Tahiti, en Polynésie française.
            </p>
            <p
              className="text-lg md:text-xl text-[#4E4A45] leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Un service dédié aux propriétaires souhaitant s'absenter en toute sérénité.
            </p>
            <p
              className="text-lg md:text-xl text-[#4E4A45] leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Notre équipe locale assure une présence fiable, discrète et exigeante, afin de préserver la qualité, la sécurité et le standing de votre bien.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
